import { render } from "./EmailVerification.vue?vue&type=template&id=28ee1956"
import script from "./EmailVerification.vue?vue&type=script&lang=js"
export * from "./EmailVerification.vue?vue&type=script&lang=js"

import "./EmailVerification.vue?vue&type=style&index=0&id=28ee1956&lang=css"
script.render = render

export default script